<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>打偷排名</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="24">
      <el-col :span="12">
        <tableData :typ="1" :title="'打次数'" :table-data="attackData" />
      </el-col>
      <el-col :span="12">
        <tableData :typ="2" :title="'偷次数'" :table-data="stealData" />
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { getAttackStealRankData } from '@/api/statistics/user_remain'
import tableData from '@/views/config/attack-steal-rank/components/table.vue'
import { getLastDates } from '@/utils'

export default {
  name: 'AttackStealRankStat',
  components: {
    tableData
  },
  data() {
    return {
      loading: false,
      activeName: 'levelId',
      platForm: [{ label: '所有', value: 0 }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }],
      attackData: [],
      stealData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        platForm: 1
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }
    this.getAttackData()
    this.getStealData()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }
      this.getAttackData()
      this.getStealData()
    },
    getAttackData() {
      this.queryParams.type = 1
      getAttackStealRankData(this.queryParams).then(res => {
        this.loading = false
        this.attackData = res.data
      })
    },
    getStealData() {
      this.queryParams.type = 2
      getAttackStealRankData(this.queryParams).then(res => {
        this.loading = false
        this.stealData = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
